import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.assign";
import _classCallCheck from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/FormControl/form-control';
import { css } from '@patternfly/react-styles';
import { ValidatedOptions } from '../../helpers/constants';
import { getOUIAProps } from '../../helpers';
export var FormSelect = /*#__PURE__*/function (_React$Component) {
  _inherits(FormSelect, _React$Component);

  var _super = _createSuper(FormSelect);

  function FormSelect(props) {
    var _this;

    _classCallCheck(this, FormSelect);

    _this = _super.call(this, props);

    _this.handleChange = function (event) {
      _this.props.onChange(event.currentTarget.value, event);
    };

    if (!props.id && !props['aria-label']) {
      // eslint-disable-next-line no-console
      console.error('FormSelect requires either an id or aria-label to be specified');
    }

    return _this;
  }

  _createClass(FormSelect, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          children = _a.children,
          className = _a.className,
          value = _a.value,
          validated = _a.validated,
          isDisabled = _a.isDisabled,
          isRequired = _a.isRequired,
          ouiaId = _a.ouiaId,
          ouiaSafe = _a.ouiaSafe,
          props = __rest(_a, ["children", "className", "value", "validated", "isDisabled", "isRequired", "ouiaId", "ouiaSafe"]);

      return React.createElement("select", Object.assign({}, props, {
        className: css(styles.formControl, className, validated === ValidatedOptions.success && styles.modifiers.success, validated === ValidatedOptions.warning && styles.modifiers.warning),
        "aria-invalid": validated === ValidatedOptions.error
      }, getOUIAProps(FormSelect.displayName, ouiaId, ouiaSafe), {
        onChange: this.handleChange,
        disabled: isDisabled,
        required: isRequired,
        value: value
      }), children);
    }
  }]);

  return FormSelect;
}(React.Component);
FormSelect.displayName = 'FormSelect';
FormSelect.defaultProps = {
  className: '',
  value: '',
  validated: 'default',
  isDisabled: false,
  isRequired: false,
  onBlur: function onBlur() {
    return undefined;
  },
  onFocus: function onFocus() {
    return undefined;
  },
  onChange: function onChange() {
    return undefined;
  },
  ouiaSafe: true
};